import { useState } from "react";
import { rankings } from "@/mocks/homeData";

const tabs = [
  { id: "week" as const, label: "本周热榜" },
  { id: "month" as const, label: "本月热榜" },
];

const deltaIcon: Record<string, { icon: string; className: string }> = {
  up: { icon: "ri-arrow-up-line", className: "text-primary-500" },
  down: { icon: "ri-arrow-down-line", className: "text-secondary-500" },
  same: { icon: "ri-subtract-line", className: "text-foreground-400" },
};

export default function HotRanking() {
  const [activeTab, setActiveTab] = useState<"week" | "month">("week");
  const list = rankings[activeTab];

  return (
    <section id="ranking" className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4">
            <span className="inline-flex items-center gap-2 font-label text-xs text-secondary-600 tracking-widest">
              <i className="ri-bar-chart-2-line" />
              RANKING
            </span>
            <h2 className="mt-3 font-heading font-black text-2xl md:text-4xl text-foreground-950">
              热度排行榜
            </h2>
            <p className="mt-4 font-body text-sm md:text-base text-foreground-600 leading-relaxed">
              基于全站阅读、讨论与转发数据综合计算的热度指数。榜单每小时刷新一次，
              本周与本月维度可自由切换。
            </p>

            <div className="mt-6 inline-flex items-center gap-1 p-1 rounded-full bg-background-100 border border-background-200">
              {tabs.map((tab) => (
                <button
                  key={tab.id}
                  type="button"
                  onClick={() => setActiveTab(tab.id)}
                  className={`cursor-pointer whitespace-nowrap font-label text-sm px-4 py-1.5 rounded-full transition-colors ${
                    activeTab === tab.id
                      ? "bg-primary-500 text-background-50"
                      : "text-foreground-600 hover:text-primary-600"
                  }`}
                >
                  {tab.label}
                </button>
              ))}
            </div>

            <div className="mt-8 rounded-lg bg-accent-50 border border-accent-200 p-5">
              <div className="flex items-center gap-2 text-accent-700">
                <i className="ri-lightbulb-flash-line" />
                <span className="font-label text-sm font-bold">榜单说明</span>
              </div>
              <p className="mt-2 font-body text-sm text-foreground-700 leading-relaxed">
                热度值越高代表该话题在统计周期内的传播范围越广。榜单不影响内容的展示顺序，
                仅作为查找入口的参考。
              </p>
            </div>
          </div>

          <div className="lg:col-span-8">
            <ol className="rounded-lg border border-background-200 bg-background-100 divide-y divide-background-200 overflow-hidden">
              {list.map((item, index) => {
                const delta = deltaIcon[item.delta];
                return (
                  <li key={item.title}>
                    <a
                      href="#trending"
                      className="group flex items-center gap-4 px-4 md:px-5 py-4 hover:bg-background-50 cursor-pointer transition-colors"
                    >
                      <span
                        className={`w-9 h-9 shrink-0 flex items-center justify-center rounded-md font-heading font-black text-base ${
                          index < 3
                            ? "bg-primary-500 text-background-50"
                            : "bg-background-200 text-foreground-600"
                        }`}
                      >
                        {item.rank}
                      </span>
                      <div className="flex-1 min-w-0">
                        <h3 className="font-heading font-bold text-sm md:text-base text-foreground-950 group-hover:text-primary-700 transition-colors truncate">
                          {item.title}
                        </h3>
                        <span className="mt-1 inline-block font-label text-xs text-secondary-600">
                          {item.group}
                        </span>
                      </div>
                      <div className="text-right shrink-0">
                        <div className="font-label text-sm font-bold text-foreground-900">
                          {item.heat}
                        </div>
                        <div className={`flex items-center justify-end gap-0.5 ${delta.className}`}>
                          <i className={`${delta.icon} text-xs`} />
                          <span className="font-label text-[11px]">
                            {item.delta === "up" ? "上升" : item.delta === "down" ? "下降" : "持平"}
                          </span>
                        </div>
                      </div>
                    </a>
                  </li>
                );
              })}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}